import React, { Component, Fragment } from 'react'
import Breadcrumbs from '../../shared/Breadcrumbs'
import { DataEgineJobRoute } from '../../routing'

export  class DatabaseEgineJobPage extends Component {
    render() {
        return (
            <Fragment>
        <Breadcrumbs />
        <DataEgineJobRoute />
      </Fragment>
        )
    }
}
